import React from "react";
import { useTranslate } from "react-admin";

const CustomerTitle = ({ record }) => {
    const translate = useTranslate();

    return (
        <span>
            {
                ! record ?    translate("customer.message.list") :
                ! record.id ? translate("customer.message.new") :
                              translate("customer.message.instance", { ...record })
            }
        </span>
    );
}

export default CustomerTitle;
